import { LocalDate } from './lib/local-date.js';
customElements.define('cipublic-local-date', LocalDate);
//# sourceMappingURL=cipublic-local-date.js.map